var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.items,"item-text":"name","item-value":"value","label":_vm.$t('dangerousGoods.dangerousGoodsList.form.fss7Relevant'),"hint":_vm.autoHint,"persistent-hint":!!_vm.autoHint,"data-cy":"fss7Relevant","dense":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }